import AuthGuardDisplay from '@components/AuthGuardDisplay';
import useUser from '@hooks/auth/useUser';
import useAppCustom from '@hooks/useAppCustom';
import { ActivityComponentType } from '@stackflow/react';
import { Fragment } from 'react';

import LoginCard from './components/LoginCard';
import MainBanners from './components/MainBanners';
import MainLayout from './components/MainLayout';
import NearBy from './components/NearBy';
import PopupBanners from './components/PopupBanners';
import QuickOrder from './components/QuickOrder';
import RecentOrders from './components/RecentOrders';
import Recommendation from './components/Recommendation';
import SubBanners from './components/SubBanners';
import UserLoading from './components/UserLoading';
import UserRewards from './components/UserRewards';
import useAndroidBackButton from './hooks/useAndroidBackButton';
import useAndroidSafeArea from './hooks/useAndroidSafeArea';
import useDeepLink from './hooks/useDeepLink';
import useForceUpdate from './hooks/useForceUpdate';
import useItemColumn from './hooks/useItemColumn';
import useLifeCycleReIssue from './hooks/useLifeCycleReIssue';
import useOpenDialog from './hooks/useOpenDialog';
import usePermission from './hooks/usePermission';
import usePushMessage from './hooks/usePushMessage';
import useRegisterToken from './hooks/useRegisterToken';
import useSetProjectId from './hooks/useSetProjectId';
import useUpdateDau from './hooks/useUpdateDau';

const MainActivity: ActivityComponentType = () => {
    const { isLoading } = useUser();
    const { useQuickMenu } = useAppCustom().main;
    usePushMessage();
    useAndroidBackButton();
    useOpenDialog();
    useAndroidSafeArea();
    useRegisterToken();
    usePermission();
    useItemColumn();
    useSetProjectId();
    useUpdateDau();
    useLifeCycleReIssue();
    useForceUpdate();
    useDeepLink();
    return (
        <MainLayout>
            <MainBanners/>
            <AuthGuardDisplay>
                {useQuickMenu ? (
                    <QuickOrder/>
                ) : (
                    <Fragment>
                        <UserRewards/>
                        <RecentOrders/>
                    </Fragment>
                )}
            </AuthGuardDisplay>
            {isLoading && (<UserLoading/>)}
            <NearBy/>
            <LoginCard/>
            <SubBanners type='MAIN_2' />
            <SubBanners type='MAIN_3' />
            <Recommendation/>
            <PopupBanners/>
        </MainLayout>
    );
};

export default MainActivity;
